/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */
import debounce from 'lodash/debounce';

function onFlySearch(phraseRaw) {
  const phrase = phraseRaw.trim().toLowerCase();
  const emptyBlock = document.querySelector('.products__empty');
  document.querySelectorAll('.js-onflywrap').forEach((wrapper) => {
    wrapper.querySelectorAll('.itemlist__title').forEach((elem) => {
      const productName = elem.innerText.trim().toLowerCase();
      const product = elem.closest('.itemlist');
      if (productName.includes(phrase) || phrase.includes(productName)) {
        product.classList.remove('is-hidden');
      } else {
        product.classList.add('is-hidden');
      }
    });
    wrapper.querySelectorAll('.itemgrid__title').forEach((elem) => {
      const productName = elem.innerText.toLowerCase();
      const product = elem.closest('.itemgrid');
      if (productName.includes(phrase) || phrase.includes(productName)) {
        product.classList.remove('is-hidden');
      } else {
        product.classList.add('is-hidden');
      }
    });
  });
  if (emptyBlock) {
    emptyBlock.classList.toggle(
      'is-visible', (
        !document.querySelector('.itemgrid:not(.is-hidden)')
      && !document.querySelector('.itemgrid:not(.is-hidden)')
      ),
    );
  }
}

export function initOnFlySearch() {
  const input = document.querySelector('.js-onflysearch');
  if (!input) return;
  input.addEventListener('input', debounce((e) => onFlySearch(e.target?.value), 100));
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.js-onflyreset');
    if (!button) return;
    e.preventDefault();
    input.value = '';
    onFlySearch('');
  });
}
